export { default } from 'features/Blog/BlogIndex'



// WEBPACK FOOTER //
// ./src/pages/BlogIndex/index.js